import React from "react"
import { Button } from "antd"
import { Tile } from "../components/masonry"
import { get } from "lodash"
import { Link } from "gatsby"

function TemplateBlock(props) {
  const { Title } = props.template.data
  const { recordId } = props.template

  const data = props.template.data
  let src = get(data, "Screenshot[0].thumbnails.large.url")

  let imageTag = get(data, "tag")

  return src ? (
    <Link to={`/section/${get(data, "Catagory[0]").toLowerCase()}/${recordId}`}>
      <div className="cwp-template-box column">
        {imageTag ? (
          <div dangerouslySetInnerHTML={{ __html: imageTag }}></div>
        ) : (
          <Tile src={src} />
        )}

        <div className="cwp-overlay"></div>
        <div className="cwp-drawer">
          <span className="template-title">{Title}</span>
          <div className="cwp-btns">
            <Button type="primary" icon="eye">
              Preview
            </Button>
          </div>
        </div>
      </div>
    </Link>
  ) : null
}

export default TemplateBlock
